import { Divider, Edit, Form, Input, SaveButton, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { CaseFieldsRadio } from "components/case/caseFieldsRadio";
import { CaseFieldsRegionRadio } from "components/case/caseFieldsRegionRadio";
import { CaseFieldsTeamRadio } from "components/case/caseFieldsTeamRadio";
import { CancelButton } from "components/utils/cancelButton";
import { ICase } from "interfaces";
import { DATAPROVIDER_UPDATE } from "scripts/site";

export const CaseEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult, form } = useForm<ICase>({
    dataProviderName: DATAPROVIDER_UPDATE
  });

  const record = queryResult?.data?.data as ICase;

  return (
    <Edit
      footerButtons={() => (
        <>
          <SaveButton  {...saveButtonProps} />
          <CancelButton />
        </>
      )}
    >
      <Form {...formProps} layout="vertical" autoComplete="off">
        <Form.Item
          label="Case Title"
          name="name"
          rules={[
            {
              required: true,
              whitespace: true,
              max: 100
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Divider dashed orientation="left" orientationMargin={0}>Region</Divider>
        <CaseFieldsRegionRadio record={record} isLoading={queryResult?.isLoading ?? true} form={form} />
        <br/>
        <Divider dashed orientation="left" orientationMargin={0}>Business Function</Divider>
        <CaseFieldsRadio record={record} isLoading={queryResult?.isLoading ?? true} form={form}>
        </CaseFieldsRadio>
        <Divider dashed orientation="left" orientationMargin={0}>Team</Divider>
        <br/>

        <CaseFieldsTeamRadio record={record} isLoading={queryResult?.isLoading ?? true} form={form} />
        <Form.Item
          label="Notes"
          name="notes">
          <Input.TextArea rows={3} placeholder="Optional notes" />
        </Form.Item>
      </Form>
    </Edit>
  );
};
